// Re-export generic format utilities from web-kit
export { downloadMarkdown, formatCents, formatMediumDate } from '@kit/lib/format.js';

/**
 * Convert a 1-based version number to a letter label (1→A, 2→B, …, 27→AA).
 * @param {number} version
 * @returns {string}
 */
export function versionLabel(version) {
    let label = '';
    let v = version;
    while (v > 0) {
        v--;
        label = String.fromCharCode(65 + (v % 26)) + label;
        v = Math.floor(v / 26);
    }
    return label;
}

/**
 * Format an asset size label, with grid dimensions for tactical maps.
 * @param {string} assetType
 * @param {string} size - miniature: 'T','S','M','L','H','G'; tactical-map: 'S','M','L'
 * @returns {string}
 */
export function sizeLabel(assetType, size) {
    if (assetType === 'tactical-map') {
        const grids = { S: 'Small (12x12)', M: 'Medium (24x24)', L: 'Large (48x48)' };
        return grids[size] || size;
    }
    const names = { T: 'Tiny', S: 'Small', M: 'Medium', L: 'Large', H: 'Huge', G: 'Gargantuan' };
    return names[size] || size;
}

/**
 * Convert a phase type slug to a display name.
 * @param {string} type
 * @returns {string}
 */
export function phaseDisplayName(type) {
    switch (type) {
        case 'composition':
            return 'Composition';
        case 'line-art':
            return 'Line Art';
        case 'sketch':
            return 'Sketch';
        case 'color-rough':
            return 'Color Rough';
        case 'final-render':
            return 'Final Render';
        case 'delivery':
            return 'Delivery';
        default:
            return type;
    }
}
